// extracted by mini-css-extract-plugin
module.exports = {"imageUploadButton":"image-upload-button_imageUploadButton__3Lv73","imageUploadIcon":"image-upload-button_imageUploadIcon__2Pv-c"};